export default "__VITE_ASSET__CeABgf_l__"